var map = {
	"./template.bet575": 1673,
	"./template.bet575.tsx": 1673,
	"./template.bet777": 1674,
	"./template.bet777.tsx": 1674,
	"./template.betbetbet": 1675,
	"./template.betbetbet.tsx": 1675,
	"./template.betstride": 1676,
	"./template.betstride.tsx": 1676,
	"./template.buffalobet": 1677,
	"./template.buffalobet.tsx": 1677,
	"./template.default": 85,
	"./template.default.tsx": 85,
	"./template.epicodds": 1678,
	"./template.epicodds.tsx": 1678,
	"./template.fiestabet": 1679,
	"./template.fiestabet.tsx": 1679,
	"./template.forsport": 1680,
	"./template.forsport.tsx": 1680,
	"./template.gigabet": 1681,
	"./template.gigabet.tsx": 1681,
	"./template.goldenbet888": 1991,
	"./template.goldenbet888.tsx": 1991,
	"./template.goldenrush": 1682,
	"./template.goldenrush.tsx": 1682,
	"./template.hyperbet": 1683,
	"./template.hyperbet.tsx": 1683,
	"./template.juicybet": 1684,
	"./template.juicybet.tsx": 1684,
	"./template.magnumbet": 1685,
	"./template.magnumbet.tsx": 1685,
	"./template.oldgill": 1686,
	"./template.oldgill.tsx": 1686,
	"./template.puntcity": 1687,
	"./template.puntcity.tsx": 1687,
	"./template.pyramidbet": 1688,
	"./template.pyramidbet.tsx": 1688,
	"./template.slambet": 1689,
	"./template.slambet.tsx": 1689,
	"./template.sterlingparker": 1690,
	"./template.sterlingparker.tsx": 1690,
	"./template.sugarcastle": 1691,
	"./template.sugarcastle.tsx": 1691,
	"./template.templebet": 1692,
	"./template.templebet.tsx": 1692,
	"./template.titanbet": 1693,
	"./template.titanbet.tsx": 1693,
	"./template.ts": 819
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2472;